import React from "react";
import {FormattedMessage, FormattedDate} from 'react-intl';
import Card   from './../components/Card';
import image1 from "./../img/image1.png";
import image2 from "./../img/image2.png";
import image3 from "./../img/image3.png";

const cards = [
  {
    id: 1,
    title: <FormattedMessage 
								id="app.title"
								defaultMessage="Seguridad Informatica"
								values={
									{
										name: 'title'
								    }
							    }/>,
    image: image1,
    servicios: <FormattedMessage 
								id="app.servicios"
								defaultMessage="Deteccion de amenazas en su infraestructura informatica."
								values={
									{
										name: 'servicios'
								    }
							    }/>,
  },
  {
    id: 2,
    title: <FormattedMessage 
								id="app.title2"
								defaultMessage="Auditoria Software"
								values={
									{
										name: 'title2'
								    }
							    }/>,
    image: image2,
    servicios: <FormattedMessage 
								id="app.servicios2"
								defaultMessage="Analisis para detectar vulnerabilidades en su software."
								values={
									{
										name: 'servicios2'
								    }
							    }/>,
  },
  {
    id: 3,
    title: <FormattedMessage 
								id="app.title3"
								defaultMessage="Asesoramiento tecnico"
								values={
									{
										name: 'title3'
								    }
							    }/>,
    image: image3,
    servicios: <FormattedMessage 
								id="app.servicios3"
								defaultMessage="Reduccion de superficie de ataque y Mitigacion de riesgos."
								values={
									{
										name: 'servicios3'
								    }
							    }/>,
  },
];

function Cards() {
  return (
  
   <div className="container d-flex justify-content-center align-items-center h-100">
   
      <div className="row">
	    <h4 class="sectioninicio">
	                  
	  
	    </h4> <span></span>
        {cards.map(({ title, image,  servicios, id }) => (
          <div className="col-md-4" key={id}>
            <Card imageSource={image} title={title} servicios={servicios} />
          </div>
        ))}
      </div>
    </div>
	
	
  );
}

export default Cards;
